import { TextInput } from "react-native";
import { useSlot, useStyled } from "use-styled";

const TextareaRoot = useStyled(TextInput, {
  base: {
    className:
      "w-full text-teachLoop-textPrimary justify-start font-geologica-regular font-normal border border-gray-200 bg-white rounded-[17] px-4 py-[18] text-left focus:outline-teal-600 placeholder:text-gray-400",
  },
  variants: {
    size: {
      sm: { className: "text-sm h-[80px]" },
      md: { className: "text-base h-[100px]" },
      lg: { className: "text-lg h-[160px]" },
      xl: { className: "text-lg h-[245px]" },
    },
    error: {
      true: { className: "border-red-500" },
    },
    disabled: {
      true: { className: "opacity-50" },
    },
  },
  defaultVariants: {
    size: "sm",
  },
});

export const Textarea = useSlot(TextareaRoot, {});
